

require('../../modules/es7.array.includes');
module.exports = require('../../modules/_core').Array.includes;


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/fn/array/includes.js
// module id = ../node_modules/core-js/fn/array/includes.js
// module chunks = 0